"use strict";

exports.__esModule = true;
var _DeviceDetailsDataProvider = require("./DeviceDetailsDataProvider");
Object.keys(_DeviceDetailsDataProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsDataProvider[key]) return;
  exports[key] = _DeviceDetailsDataProvider[key];
});